import contractClaimTranslations from "./contractClaimTranslations";

const membershipContractTranslations = {
  ...contractClaimTranslations,
  label: "Mitgliedschaft",
  reasonForDispute: {
    label: "Problem mit Mitgliedschaft",
    values: {
      serviceUnavailable: "Mitgliedschaft nicht (voll) nutzbar",
      cancellationRefused: "Kündigung wurde nicht akzeptiert",
      invoiceIncorrect: "Fehlerhafte Rechnung erhalten",
      cancellationByContractPartner: "Vertrag wurde von Vertragspartner gekündigt",
      other: "Anderes Problem",
      priceIncrease: "Vertragspartner hat die Preise erhöht",
    },
  },
  serviceUnavailableOffer: {
    label: "Ersatzangebot des Gegners",
    values: {
      coupon: "Gutscheine",
      freeMonths: "Freimonate",
      couponFreeMonths: "Gutscheine und Freimonate",
      noOffer: "Kein Angebot",
    },
  },
  cancellationDate: {
    label: "Kündigungsdatum",
  },
  endOfContractDate: {
    label: "Datum Vertragsende",
  },
  contractNumber: {
    label: "Vertrags-/Mitgliedsnummer",
  },
  membershipType: {
    label: "Art der Mitgliedschaft",
    values: {
      gym: "Fitnessstudio",
      club: "Verein",
      other: "Andere Mitgliedschaft",
    },
  },
  feePaymentFrequency: {
    label: "Zahlung erfolgt",
    values: {
      monthly: "Monatlich",
      quarterly: "Pro Quartal",
      yearly: "Jährlich",
    },
  },
  fee: {
    label: "Betrag",
  },
  serviceUnavailableFromDate: {
    label: "Nicht nutzbar von",
  },
  serviceUnavailableToDate: {
    label: "Nicht nutzbar bis",
  },
  numberDaysAvailableInBetween: {
    label: "Anzahl nutzbare Tage",
  },
  priceIncreaseAnnouncementDate: {
    label: "Datum Ankündigung Preiserhöhung",
  },
  numberUnpaidPeriods: {
    label: "Anzahl nicht bezahlter Perioden",
  },
  opponentReactionToCancellation: {
    label: "Reaktion Gegenseite auf Kündigung",
    values: {
      noReaction: "Keine Reaktion",
      cancellationRefused: "Kündigung abgelehnt",
      differentDate: "Anderes Kündigungsdatum/Verlängerung",
    },
  },
  endOfContractDateOpponent: {
    question: "Zu welchem Datum endet laut Gegenseite Ihr Vertrag?",
    label: "Vertragsende laut Gegenseite",
  },
};

export default membershipContractTranslations;
